import {type ReactNode} from 'react'
import {View} from 'react-native'

import {IS_WEB} from '#/env'
import {useSession} from '#/state/session'
import {atoms as a, web} from '#/alf'
import {LoggedOutFooter} from './bottom-bar/BottomBarWeb'

/**
 * Wraps a logged-out web page's content so the content flows normally and the
 * footer sits at the true end of the page (sticky-footer pattern): on short
 * pages the footer rests at the bottom of the viewport, on long pages you
 * scroll down to reach it. Renders children as-is for logged-in / native.
 */
export function LoggedOutPage({children}: {children: ReactNode}) {
  const {hasSession} = useSession()

  if (!IS_WEB || hasSession) {
    return <>{children}</>
  }

  return (
    <View
      style={web({
        minHeight: 'calc(100dvh - 60px)',
        display: 'flex',
        flexDirection: 'column',
      } as any)}>
      <View style={a.flex_1}>{children}</View>
      <LoggedOutFooter />
    </View>
  )
}
